<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="elevation-3">
          <v-card-text>
            <v-layout justify-center align-center>
              <v-flex xs12 class="customer-table">
                <pivot
                  fields-label-text="Columnas activos"
                  columns-label-text="Totales activos"
                  available-colums-label-text="Totales disponibles"
                  available-fields-label-text="Columnas disponibles"
                  :data="data"
                  :filters="filters"
                  :fields-list="lists.fieldsList"
                  :columns-list="lists.columnsList"
                  :default-columns="defaultColumns"
                  @loading="clearData"
                  @loaded="setData">
                  <filters-bar
                    title="Clientes"
                    title-class="headline"
                    :date="false"
                    :filters="filters"
                    :has-date-type="false"
                    :custom-filters="customFilters"
                    @search="applyFilters">
                      <template slot="content">
                        <v-flex md3 mr-3 align-center d-flex>
                          <actual-button :filters="filters"></actual-button>
                        </v-flex>
                        <v-flex md2 mr-3>
                          <v-btn
                            class="h-100 ma-0 w-100 btn-filter"
                            @click="generateReport">
                            <v-icon small>fas fa-download</v-icon>
                          </v-btn>
                        </v-flex>
                      </template>
                  </filters-bar>
                </pivot>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Pivot from '@/components/global/report_datatables/Pivot';
import FiltersBar from '@/components/global/FiltersBar';
import ActualButton from '@/components/panelV2/ActualButton';

export default {
  components: {
    Pivot,
    FiltersBar,
    ActualButton,
  },
  mounted() {
    this.$store.dispatch('GET_TRANCHE_STATUS');
  },
  data() {
    return {
      dialog: false,
      data: [],
      customFilters: [
        {
          text: 'Estado',
          value: 'customer_status',
        },
        {
          text: 'Etapa de la gestión',
          value: 'ns_stage_id',
        },
        {
          text: 'Estado del tramo',
          value: 'trancheStatus',
        },
        {
          text: 'Ultimo canal de gestión',
          value: 'last_n_channel_id',
        },
        {
          text: 'Ultimo canal de contacto',
          value: 'last_r_channel_id',
        },
        {
          text: 'Ultimo canal de contacto util',
          value: 'last_c_channel_id',
        },
      ],
      filters: {
        total_load: 0,
        code: 'CTMS',
      },
      defaultColumns: [
        {
          label: 'Total',
          value: 'total',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'dimentions',
    ]),
    dims() {
      if (this.dimentions.length) {
        return this.dimentions.map((item) => {
          const { title, name } = item;
          const obj = {};
          obj.label = title;
          obj.value = name;
          return obj;
        });
      }
      return [];
    },
    lists() {
      const lists = {
        fieldsList: [
          {
            label: 'Estado',
            value: 'customer_status',
          },
          {
            label: 'Etapa del arbol de gestión',
            value: 'workflow_stage',
          },
          {
            label: 'Etapa de la gestión',
            value: 'ns_stage_id',
          },
          {
            label: 'Estado del tramo',
            value: 'tranche_status',
          },
          {
            label: 'Ultimo canal de gestión',
            value: 'last_n_channel_id',
          },
          {
            label: 'Ultimo canal de contacto',
            value: 'last_r_channel_id',
          },
          {
            label: 'Ultimo canal de contacto util',
            value: 'last_c_channel_id',
          },
          {
            label: 'Ultima promesa de pago',
            value: 'payment_promise',
          },
          {
            label: 'Ultima fecha de gestion',
            value: 'last_notification',
          },
          {
            label: 'Ultima fecha de contacto',
            value: 'last_reached',
          },
          {
            label: 'Ultima fecha de contacto util',
            value: 'last_contact',
          },
          {
            label: 'Agencia',
            value: 'agency',
          },
          {
            label: 'Tramo',
            value: 'tranche',
          },
          {
            label: 'Vencimiento',
            value: 'due_day',
          },
          {
            label: 'Portafolio',
            value: 'portfolio_type',
          },
          {
            label: 'Tipo de cuenta',
            value: 'account_type',
          },
          {
            label: 'Agente',
            value: 'agent',
          },
          {
            label: 'Genero',
            value: 'gender',
          },
          {
            label: 'Grupo de edad',
            value: 'age_group',
          },
          {
            label: 'Estado / Región ',
            value: 'state',
          },
          {
            label: 'Última carga',
            value: 'last_sync_date',
          },
          {
            label: 'Fecha de vencimiento',
            value: 'due_date',
          },
          {
            label: 'Días de mora',
            value: 'delinquency',
          },
          ...this.dims,
        ],
        columnsList: [
          {
            label: 'Saldo de deuda',
            value: 'due_balance',
          },
          {
            label: 'Saldo facturado',
            value: 'invoiced_balance',
          },
          {
            label: 'Saldo total',
            value: 'total_balance',
          },
          {
            label: 'Saldo capital',
            value: 'principal_balance',
          },
          {
            label: 'Saldo provisionado',
            value: 'provision_balance',
          },
          {
            label: 'Saldo del prestamo',
            value: 'loan_amount',
          },
          {
            label: 'Saldo pagado',
            value: 'paid_balance',
          },
        ],
      };
      lists.fieldsList = _.sortBy(lists.fieldsList, ['label']);
      return lists;
    },
  },
  methods: {
    generateReport() {
      this.$store.commit('SET_DOWNLOAD_CHANNEL', `company.${this.$auth.user().company.id}.${this.$auth.user().id}.download_report`);
      this.$store.dispatch('SEND_DOWNLOAD_REQUEST', {
        route: 'reports',
        params: {
          filters: {
            ...this.filters,
          },
          functionName: 'customerReport',
        },
      });
    },
    clearData() {
      this.data = [];
      this.isDataLoading = true;
    },
    setData($event) {
      this.data = $event;
      this.isDataLoading = false;
    },
    applyFilters($event) {
      this.filters = {
        ...this.filters,
        ...$event,
      };
    },
  },
};
</script>
<style scoped>
.customer-table >>> .btn-total-load {
  height: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/reports/customer/Index.vue